<template>
    <form-wrapper @submit="handleFormSubmission(data)">
        <intake-form-section>
            <form-row v-for="question in screeningQuestions" :key="question.path">
                <form-cell>
                    <tabs-field
                        :label="question.label"
                        :options="triStateOptions"
                        :formData="data"
                        :valuePath="question.path"
                        size="small"
                        @change="change($event)"
                    ></tabs-field>
                </form-cell>
            </form-row>
        </intake-form-section>

        <template #footer>
            <common-buttons>
                <common-button
                    :label="$t('common.microcopy.back')"
                    type="secondary"
                    size="large"
                    :isSubmittable="false"
                    @click="goBack"
                ></common-button>
                <common-button
                    :label="$t('common.microcopy.next')"
                    type="primary"
                    size="large"
                    :isProcessing="isSending"
                ></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import IntakeFormSection from 'components/forms/intake/IntakeFormSection'

    const SCREENING_FIELDS = ['bladderControlLoss', 'bowelControlLoss', 'groinNumbness', 'worseningWeakness', 'difficultyWalking']

    export default {
        mixins: [FormMixin],

        components: {
            IntakeFormSection,
        },

        props: {
            initialData: { type: Object, default: undefined },
        },

        data() {
            const defaults = SCREENING_FIELDS.reduce((acc, path) => {
                acc[path] = 'no'
                return acc
            }, {})

            return {
                data: {
                    ...defaults,
                    ...(this.initialData || {}),
                },
            }
        },

        computed: {
            screeningQuestions() {
                return SCREENING_FIELDS.map((path) => ({
                    path,
                    label: this.$t(`forms.intake.health_screening.fields.${path}.label`),
                }))
            },

            triStateOptions() {
                return ['yes', 'no', 'unsure'].map((value) => ({
                    label: this.$t(`forms.intake.what_happened.fields.tri_state.options.${value}`),
                    value,
                }))
            },
        },

        methods: {
            goBack() {
                this.emitEvent({ name: 'back', payload: this.data })
            },

            handleFormSubmission(data) {
                this.isSending = true
                this.emitSent(data)
                this.isSending = false
            },
        },
    }
</script>
